/**
 * 在具備 token 與 tenant_id 時於 mount 時呼叫 Bootstrap API 並寫入 SWR 快取，
 * 讓首屏（或重新整理後）的 useTenant、useFeatureFlags、useCurrentUserRole 命中快取。
 */

import { useEffect, useRef } from 'react';
import { fetchBootstrap, hydrateSwrFromBootstrap } from '../lib/bootstrap';

/**
 * 當 token 與 tenant_id 存在且不在 tenant-select 頁時，呼叫一次 Bootstrap 並 hydrate SWR。
 * 僅執行一次（依 token + tenant_id 組合），避免重複請求。
 */
export function useBootstrapOnMount(): void {
  const hasRunRef = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const token =
      localStorage.getItem('tenant_token') ||
      localStorage.getItem('staff_session_token');
    const tenantId = localStorage.getItem('tenant_id');

    const isLobbyPage =
      window.location.pathname === '/tenant-select' ||
      window.location.pathname.includes('/tenant-select');

    if (!token || !tenantId || isLobbyPage) return;

    const key = `${token.slice(0, 20)}-${tenantId}`;
    if (hasRunRef.current === key) return;
    hasRunRef.current = key;

    let cancelled = false;
    fetchBootstrap(token, tenantId)
      .then(res => {
        if (cancelled || !res.success || !res.data) return;
        hydrateSwrFromBootstrap(res.data, tenantId, token);
      })
      .catch(() => {
        // 靜默失敗，後續各頁會 fallback 到個別 API
      });

    return () => {
      cancelled = true;
    };
  }, []);
}
